<div class="qr-sheet">
  <h3 class="qr-title">{{ "diffusion-qr.title" | translate }}</h3>

  @switch (status()) {
    @case ('loading') {
    <div class="qr-frame qr-loading" role="status">
      <ion-spinner name="crescent" />
    </div>
    }
    @case ('error') {
    <div class="qr-error" role="alert">
      <ion-icon name="alert-circle-outline" aria-hidden="true" />
      <p>{{ errorKey() | translate }}</p>
    </div>
    <div class="qr-actions">
      <app-main-button [label]="'diffusion-qr.retry'" (clicked)="retry()" />
    </div>
    }
    @default {
    <div class="qr-frame">
      <img [src]="imageUrl()" [alt]="'diffusion-qr.image-alt' | translate" />
    </div>

    <div class="qr-url">
      <span class="qr-url-label">{{ "diffusion-qr.url-label" | translate }}</span>
      <span class="qr-url-value">{{ qrUrl() }}</span>
    </div>

    <div class="qr-actions">
      @if (isNative) {
      <app-main-button [label]="'diffusion-qr.share-print'" (clicked)="shareNative()" />
      } @else {
      <app-main-button [label]="'diffusion-qr.download'" (clicked)="download()" />
      <app-secondary-button [label]="'diffusion-qr.print'" [topPadding]="false" (clicked)="print()" />
      @if (canShareFiles) {
      <app-secondary-button [label]="'diffusion-qr.share'" [topPadding]="false" (clicked)="shareWeb()" />
      }
      }
    </div>
    }
  }
</div>
